export default function ScoreBreakdown({ atsParsing, jobMatch, recruiterImpact }) {

  const getValue = (val) => {
    if (val === "PASS" || val === "HIGH") return 90;
    if (val === "MEDIUM") return 60;
    return 30;
  };

  const getColor = (value) => {
  if (value >= 70) return "bg-green-500";
  if (value >= 50) return "bg-yellow-500";
  return "bg-red-500";
};
  const data = [
    { label: "ATS Parsing", value: getValue(atsParsing) },
    { label: "Job Match", value: getValue(jobMatch) },
    { label: "Recruiter Impact", value: getValue(recruiterImpact) }
  ];

  return (
    <div className="bg-white p-6 rounded-xl shadow">

      <h3 className="text-lg font-semibold mb-4">
        📊 Score Breakdown
      </h3>

      <div className="space-y-4">

        {data.map((item, i) => (
          <div key={i}>
            <div className="flex justify-between text-sm mb-1">
              <span>{item.label}</span>
              <span>{item.value}%</span>
            </div>

            <div className="w-full bg-gray-200 h-2 rounded">
              <div
                className="h-2 bg-blue-600 rounded"
                style={{ width: `${item.value}%` }}
              />
            </div>
          </div>
        ))}

      </div>
    </div>
  );
}